import styled from 'styled-components';

export const WhatWeDoMobileWrapper = styled.section`
  background-color: #fff;
  padding-top: 50px;
  padding-bottom: 50px;
  display: block;
  @media (min-width: 768px) {
    display: none;
  }
`;
export const WhatWeDoMobileContainer = styled.div`
  max-width: 1696px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  padding: 0px 15px;
`;
export const WhatWeDoMobileHeader = styled.div`
  h2 {
    color: #000;
    font-size: 14px;
    line-height: 14px;
    margin: 0px;
  }
`;
export const WhatWeDoMobileTabHeaderWrapper =styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
`
export const WhatWeDoMobileTab = styled.h5`
  margin: 0px;
  text-transform: uppercase;
  border: 1px solid #e6e6e6;
  background: var(--white, #fff);
  color: #4a4a4a;
  font-size: 11px;
  font-weight: 500;
  line-height: 1;
  text-align: center;
  font-weight: 500;
  cursor: pointer;
  padding:8px 12px;
  &.active-tab {
    background-color: #3b79d6;
    color: #fff !important;
  }
`;
export const WhatWeDoMobileBody = styled.div`
  padding-top: 20px;
  .swiper-wrapper {
    .swiper-slide {
      position: relative;
      padding-right: 20px;
      padding-left: 20px;
      padding-top: 15px;
      padding-bottom: 15px;
      border: 2px solid #b4b4b4;
      &.swiper-slide-active {
        .mobile-tab {
          color: #3b79d6;
        }
      }
    }
  }
`;
export const WhatWeDoMobileContent = styled.div`
  padding-top: 20px;
  flex-direction: column;
  display: none;
  &.active-tab {
    display: flex !important;
    justify-content: center;
  }
`;
export const WhatWeDoMobileContentParagraph = styled.div`
  width: 100%;
  &[dir='ltr'] {
    text-align: left;
  }
  &[dir='rtl'] {
    text-align: right;
  }
  h3 {
    font-size: 15px;
    line-height: 21px;
    color: #000;
    margin-bottom: 0px;
    padding-bottom: 29px;
    &[dir='ltr'] {
      font-family: Baskerville;
    }
  }
  p {
    font-size: 13px;
    line-height: 18px;
    color: #898989;
    margin-bottom: 0px;
    padding-bottom: 15px;
  }
`;
export const WhatWeDoMobileContentImage = styled.div`
  width: 100%;
  padding-top: 10px;
  span {
    width: 100%;
  }
`;

export const WhatWeDoDesktopWrapper = styled.section`
  background-color: #fff;
  padding-top: 100px;
  padding-bottom: 100px;
  display: none;
  @media (max-width: 992px) {
    padding-top: 70px;
    padding-bottom: 70px;
  }
  @media (min-width: 768px) {
    display: block;
  }
`;
export const WhatWeDoDesktopContainer = styled.div`
  max-width: 1170px;
  margin: 0 auto;
  position: relative;
  text-align: center;
  @media (max-width: 1200px) {
    max-width: 1100px;
    padding-left: 15px;
    padding-right: 15px;
  }
  @media (max-width: 992px) {
    max-width: 960px;
  }
  @media (max-width: 768px) {
    max-width: 720px;
  }
  @media (max-width: 576px) {
    max-width: 540px;
  }
`;
export const WhatWeDoDesktopHeader = styled.div`
  h2 {
    font-size: 30px;
    font-weight: 400;
    line-height: 30px;
    color: #000000;
    margin-bottom: 0px;
    @media (max-width: 1199px) {
      font-size: 26px;
      line-height: 30px;
      margin-bottom: 0px;
    }
    @media (max-width: 768px) {
      font-size: 20px;
      line-height: 30px;
      margin-bottom: 0;
    }
  }
`;
export const WhatWeDoDesktopTabHeader = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;
export const WhatWeDoDesktopTab = styled.h5`
  font-size: 18px;
  color: #b4b4b4;
  line-height: 20px;
  font-weight: 500;
  text-transform: uppercase;
  margin: 0px;
  cursor: pointer;
  padding-right: 45px;
  padding-left: 45px;
  position: relative;
  @media (max-width: 1200px) {
    font-size: 15px;
    padding-right: 35px;
    padding-left: 35px;
  }
  @media (max-width: 992px) {
    font-size: 14px;
    padding-right: 20px;
    padding-left: 20px;
  }
  &.active-tab {
    color: #3b79d6;
  }
  &:before {
    content: '';
    position: absolute;
    background-color: #b4b4b4;
    height: 20px;
    width: 2px;
    right: 0%;
    top: 2px;
  }
  &[dir='ltr'] {
    &:last-child {
      &:before {
        content: '';
        display: none;
      }
    }
  }
  &[dir='rtl'] {
    &:first-child {
      &:before {
        content: '';
        display: none;
      }
    }
  }
`;
export const WhatWeDoDesktopBodyWrapper = styled.div`
  padding-top: 50px;
  @media (max-width: 992px) {
    padding-top: 25px;
  }
`;
export const WhatWeDoDesktopContent = styled.div`
  display: none;
  flex-direction: row;
  column-gap: 113px;
  padding-top: 50px;
  @media (max-width: 1440px) {
    column-gap: 50px;
  }
  @media (max-width: 992px) {
    padding-top: 25px;
  }
  &.active-tab {
    display: flex !important;
    justify-content: center;
  }
`;
export const WhatWeDoDesktopContentParagraph = styled.div`
  width: 375px;
  &[dir='ltr'] {
    text-align: left;
  }
  &[dir='rtl'] {
    text-align: right;
  }
  h3 {
    font-size: 30px;
    line-height: 42px;
    color: #000000;
    margin-bottom: 0px;
    padding-bottom: 24px;
    @media (max-width: 1450px) {
      font-size: 28px;
    }
    @media (max-width: 1300px) {
      font-size: 25px;
      line-height: 38px;
      padding-bottom: 20px;
    }
    @media (max-width: 1200px) {
      font-size: 20px;
      line-height: 35px;
    }
  }
  p {
    font-size: 14px;
    line-height: 20px;
    color: #898989;
    margin-bottom: 0px;
    padding-bottom: 16px;
    &:last-child {
      padding-bottom: 0px;
    }
  }
`;
export const WhatWeDoDesktopContentImage = styled.div`
  width: 682px;
  @media (max-width: 1800px) {
    width: 682px;
  }
  @media (max-width: 1200px) {
    width: 500px;
  }
  span {
    width: 100%;
    height: 100%;
    img {
      object-fit: cover;
    }
  }
`;
export const PrevButton = styled.button`
  outline: none;
  border: none;
  background: none;
  position: absolute;
  top: 18%;
  cursor: pointer;
  height: 35px;
  width: 35px;
  background: #f2f2f2;
  border-radius: 50%;
  z-index: 9;
  @media (max-width: 992px) {
    left: 0px;
    svg {
      width: 10px;
      height: 16px;
      margin-top: 3px;
    }
  }
`;
export const NextButton = styled.div`
  outline: none;
  border: none;
  background: none;
  position: absolute;
  top: 18%;
  cursor: pointer;
  height: 35px;
  width: 35px;
  background: #f2f2f2;
  border-radius: 50%;
  z-index: 9;
  @media (max-width: 992px) {
    right: 0px;
    svg {
      width: 10px;
      height: 16px;
      margin-top: 9px;
    }
  }
`;
